// extracted by mini-css-extract-plugin
export default {"containerBorder":"ConfirmAddAccount_containerBorder__laSJu"};